
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import Dialog from '@/components/dialog.vue';
	import UploadImg from '@/components/upload-img.vue';
  import {
    orderorderInvoiceUpload
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-dialog': Dialog,
      UploadImg
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:false}) show:boolean
    @Prop({default:()=>{}}) row:any
    @Prop({default:1}) type:number
    private dialogShow = false
    private file:any = []

    @Watch('show')
    private watchShow(val){
      this.dialogShow = val
    }


    private async confirmUpload(){
      if(!this.file.length){
        this.$message.error('请先上传文件')
        return
      }
      try{
        let res = await orderorderInvoiceUpload({
          InvoiceUploadWay:this.type,
          OrderNo:this.row.OrderNo,
          Id:this.row.Id,
          OrderInvoiceUrl:this.file[0].url,
          OrderInvoiceName:this.file[0].name,
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.close()
        }
      }finally{
        //
      }
    }
    private uploadSuc(e){
      this.file = e
    }
    private close(){
      this.dialogShow = false
      this.$emit('close')
    }
  }
